export function ValidateEmail(email) {
  if (email === '' || email === undefined) return true;
  const re = /\S+@\S+\.\S+/;
  return re.test(email);
}

export function validPassword(password) {
  if (password === '' || password === undefined) return true;
  if (password.length < 8) return false;

  const capitalRegex = /[A-Z]/;
  const lowercaseRegex = /[a-z]/;
  const numberRegex = /\d/;
  const nonAlphaNumericRegex = /[~!@#$%^&*_\-+=`|\\(){}[\]:;"'<>,.?/]/;

  if (!capitalRegex.test(password)) return false;
  if (!lowercaseRegex.test(password)) return false;
  if (!numberRegex.test(password)) return false;
  if (!nonAlphaNumericRegex.test(password)) return false;

  return true;
}

export function notEmpty(value, validator) {
  if (value === '' || value === undefined) return false;
  return validator(value);
}

export function validPhone(phone) {
  if (phone === '' || phone === undefined) return true;
  const re = /^[+\d]{8,}$/;
  return re.test(phone);
}
